import script from "./OrderBookView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderBookView.vue?vue&type=script&setup=true&lang=js"

import "./OrderBookView.vue?vue&type=style&index=0&id=452e9f88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452e9f88"]])

export default __exports__